module.exports = __webpack_public_path__ + "img/play-store-2468551.png";